export default {
  name: "clientLog",
  data() {
    return {
      list: {},
      api: '',
      columns: [
        { prop: 'port', label: '端口', formatter: row => {
            let _a = '';
            switch (row.port) {
              case 1: _a = '擎想系统windows直播端'; break;
              case 2: _a = '学生ios端'; break;
              case 3: _a = '学生安卓端'; break;
              default: _a = '--';
            }
            return _a;
          } },
        { prop: 'name', label: '对应校区', formatter: row => (row.name || row.name == 0) ? row.name : '--' },
        { prop: 'login_user', label: '用户账号', formatter: row => (row.login_user || row.login_user == 0) ? row.login_user : '--' },
        { prop: 'created_at', label: '上传时间', formatter: row => (row.created_at || row.created_at == 0) ? row.created_at : '--' },
        { prop: 'status', label: '上传状态', formatter: row => {
            let _a = '';
            switch (row.status) {
              case 1: _a = '上传成功'; break;
              case 2: _a = '上传失败'; break;
              default: _a = '--';
            }
            return _a;
          } },
        { prop: 'file', label: '日志文件', },
        { prop: 'exception_type', label: '异常类型', formatter: row => {
            let _a = '';
            switch (row.exception_type) {
              case 1: _a = '闪退'; break;
              case 2: _a = '下载异常'; break;
              case 3: _a = '直播异常'; break;
              case 4: _a = '其他'; break;
              default: _a = '--';
            }
            return _a;
          } },
        { prop: 'remarks', label: '异常描述备注', },
        { prop: 'image', label: '异常图片', width: 140 } ,
        { prop: 'device', label: '电脑/手机机型', formatter: row => (row.device || row.device == 0) ? row.device : '--' },
        { prop: 'version', label: '系统版本', formatter: row => (row.version || row.version == 0) ? row.version : '--' },
      ],
      dialogImg: {
        show: false,
        src: '',
      }
    }
  },
  computed: {
    searchArr() {
      return [
        {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
        {
            selectValue: [
              {
                name: '擎想系统windows直播端',
                value: 1
              },
              {
                name: '学生ios端',
                value: 2
              },
              {
                name: '学生安卓端',
                value: 3
              }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'port',
            placeholder: '端口'
          },
        { componentType: 'AppSearchColumn', searchType: [
            { prop: 'name', label: '校区名称' },
            { prop: 'login_user', label: '用户账号' },
          ] },
      ];
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/ClientLog/index.js